module.exports = __webpack_public_path__ + "img/Dudey.8f2dfefe.png";